/* eslint-disable */
import { notification, Icon } from 'antd';
import { saveAs } from 'file-saver';
import htmlDocx from 'html-docx-js/dist/html-docx';
import React from 'react';
import './style.css';
import { InfoCircleOutlined, ExclamationCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';

const openNotification = (title, icon, className) => {
    notification.open({
        message: title,
        //   description:description,
        icon: icon,
        className: className
    });
}
//提示信息
let Alert = (type, description) => {
    if (type === "success") {
        const successIcon = <CheckCircleOutlined style={{ fontSize: "25px", color: "#52c41a" }} />
        openNotification(description, successIcon, "success-alert");
    } else if (type === "error") {
        const errorIcon = <InfoCircleOutlined style={{ fontSize: "25px", color: "#f5222d" }} />
        openNotification(description, errorIcon, "error-alert");
    } else if (type === "warn") {
        const warnIcon = <ExclamationCircleOutlined style={{ fontSize: "25px", color: "#faad14" }} />
        openNotification(description, warnIcon, "warn-alert");
    } else if (type === "info") {
        const warnIcon = <InfoCircleOutlined style={{ fontSize: "25px", color: "#6EBBFF" }} />
        openNotification(description, warnIcon, "info-alert");
    }
}
let goLogin = () => {
    let href = window.location.href.replace("#", "@");
    window.location.href = window.location.protocol + "//" + window.location.host + "/client/?next=" + href;
}
let srcUrl = (str) => {
    const pa = []
    let externalUrl = false;
    // 匹配图片（g表示匹配所有结果i表示区分大小写）
    var imgReg = /<img.*?(?:>|\/>)/gi
    // 匹配src属性
    var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i
    var arr = str.match(imgReg)
    // alert('所有已成功匹配图片的数组：' + arr)
    if (arr) {
        for (var i = 0; i < arr.length; i++) {
            var src = arr[i].match(srcReg)
            // 获取图片地址
            if (src[1] && (src[1].indexOf('https://') !== -1 || src[1].indexOf('http://') !== -1 || src[1].indexOf('file://') !== -1)) {
                // alert('已匹配的图片地址' + (i + 1) + '：' + src[1])
                pa.push(src[1])
            }
        }
    }
    if (pa.length > 0) {
        externalUrl = true
    } else {
        externalUrl = false
    }
    return externalUrl
}
const exportToWordWithFixedImages = async (editorState, fileName = 'document.docx') => {
    try {
        // 1. 获取编辑器中的HTML内容
        const rawHtml = editorState.toHTML();

        // 2. 创建一个临时容器来处理HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = rawHtml;

        // 3. 处理所有图片：将在线图片转换为Base64
        const images = tempDiv.getElementsByTagName('img');
        const imageConversionPromises = Array.from(images).map((img) => {
            // 跳过已经是Base64格式的图片
            if (img.src.startsWith('data:')) return Promise.resolve();

            return new Promise((resolve) => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                const imgElement = new Image();

                // 处理跨域图片
                imgElement.crossOrigin = 'Anonymous';
                imgElement.onload = () => {
                    canvas.width = imgElement.width;
                    canvas.height = imgElement.height;
                    ctx.drawImage(imgElement, 0, 0);
                    // 转换为Base64
                    img.src = canvas.toDataURL('image/png');
                    resolve();
                };
                imgElement.onerror = () => {
                    console.warn(`图片加载失败: ${img.src}`);
                    resolve(); // 即使失败也继续执行
                };
                imgElement.src = img.src;
            });
        });

        // 等待所有图片转换完成
        await Promise.all(imageConversionPromises);
        const maxDisplayWidth = 550; // 根据Word文本区域宽度调整此值
        const imagesForExport = tempDiv.getElementsByTagName('img');

        for (let img of imagesForExport) {
            await new Promise((resolve) => {
                const imgElement = new Image();
                imgElement.src = img.src;

                imgElement.onload = () => {
                    const originalWidth = imgElement.width;
                    const originalHeight = imgElement.height;

                    // 计算缩放后的尺寸[6](@ref)
                    let newWidth = originalWidth;
                    let newHeight = originalHeight;

                    // 如果图片原始宽度超过最大允许宽度，则进行缩放[7](@ref)
                    if (originalWidth > maxDisplayWidth) {
                        newWidth = maxDisplayWidth;
                        newHeight = (originalHeight / originalWidth) * newWidth; // 等比例缩放高度
                    }

                    // 关键：使用width和height属性直接设置图片尺寸[8](@ref)
                    img.setAttribute('width', newWidth);
                    img.setAttribute('height', newHeight);

                    // 移除可能冲突的CSS样式，避免干扰
                    img.style.width = '';
                    img.style.height = '';
                    img.style.maxWidth = '';

                    resolve();
                };

                // 如果图片已经加载完成，则立即执行
                if (imgElement.complete) {
                    imgElement.onload();
                }
            });
        }
        // 4. 构建完整的HTML文档
        const fullHtml = `
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <style>
                    body { font-family: 微软雅黑, Arial, sans-serif; }
                    img { max-width: 100%; height: auto; }
                    </style>
                </head>
                <body>${tempDiv.innerHTML}</body>
                </html>
                `;

        // 5. 转换为Word并下载
        const converted = htmlDocx.asBlob(fullHtml);
        saveAs(converted, fileName);

    } catch (error) {
        console.error('导出Word失败:', error);
        alert('导出失败，请检查控制台信息');
    }
};
export {
    Alert,
    goLogin,
    srcUrl,
    exportToWordWithFixedImages
};